import { Component, OnDestroy, OnInit } from '@angular/core';
import { PayJustNowService } from '../../../services/pay-just-now/pay-just-now.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../services/session/session.service';
import { Session } from '../../../interfaces/session-data';
import { CreateCheckoutResponse } from '../../../interfaces/pay-just-now/create-checkout-response';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pay-just-now',
  templateUrl: './pay-just-now.component.html',
  styleUrls: ['./pay-just-now.component.scss']
})
export class PayJustNowComponent implements OnInit, OnDestroy {
  loading = true;
  controllerUrl!: SafeResourceUrl;
  //Countdown
  config = { leftTime: 5, format: 's' };

  // iframe
  public iframeLoaded:boolean;
  public iframePostback:boolean;
  private boundHandleIframeLoad:any;

  sessionData: Session;
  constructor(
      private payJustNowService: PayJustNowService,
      private sessionService: SessionService,
      private router: Router,
      private sanitizer: DomSanitizer
    ) {
    sessionStorage.setItem('selected-payment', 'pay-just-now');
    this.boundHandleIframeLoad = this.handleIframeLoad.bind(this);
    this.iframeLoaded = false;
    this.iframePostback = false;
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundHandleIframeLoad);
  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    // this.controllerUrl = `${environment.production ? 'https://' : 'http://'}${window.location.hostname ? 'localhost:7000' : 'localhost:4200'}}`;

    window.addEventListener('message', this.boundHandleIframeLoad, false);
    this.payJustNowService.initialize(sessionStorage.getItem('sessionToken')).subscribe((data: CreateCheckoutResponse) => {
      this.controllerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.paymentUrl);
      const timeout = 5;
      // setTimeout(() => {
        // window.location.href = data.redirectUrl;
        // const redirectRequest = <RedirectRequest>({redirectUrl: data.redirectUrl});
        // (document.getElementById('pay-just-now-form') as HTMLFormElement).submit();
        // this.masterPassService.redirectMasterPass(sessionStorage.getItem('sessionToken'), redirectRequest).subscribe();
      // }, timeout * 1000);
    });
  }

  private handleIframeLoad(event: MessageEvent) {
    console.log(event);
    // Check if the message is from the expected origin

    // Handle the response from the iframe
    if (event.data.event == 'checkout:paymentsuccess' || /^https:\/\/(?:[a-zA-Z0-9-]+\.)*adumoonline\.com(\/|$)/.test(event.origin) && event.data.status === 'COMPLETED' && event.data.paymethod==='PAY_JUST_NOW') {
      // Redirect the parent window
      this.iframeLoaded = false;
      this.iframePostback = true;
      this.payJustNowService.validate(sessionStorage.getItem('sessionToken')).subscribe(()=>{
        this.navigateToStatus();
      })
    }
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
  }

  iframeOnLoad(event:any){
    if(!this.iframePostback){
      this.iframeLoaded = true;
    }
  }
}
